import { graphql } from 'gql.tada';

export const FamilyListItemFragment = graphql(`
  fragment FamilyListItemFragment on Family {
    id
    name
    slug
    studentCount
    primaryContactEmail
    primaryContactPhone
    guardians {
      person {
        id
        firstName
        lastName
      }
    }
  }
`);
